import React from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { BrandLogo } from "../../components/brandLogo";
import { Button } from "../../components/button";
import { Marginer } from "../../components/marginer";
import { deviceSize } from "../../components/responsive";

import TopSectionBackgroundImg from "../../images/inicio.jpg";
import TheBestSpecialistsImg from "../../images/Work only with the best.png";

const TopSectionContainer = styled.div`
  width: 100%;
  height: 800px;
  background: url(${TopSectionBackgroundImg}) no-repeat;
  background-position: 0px -150px;
  background-size: cover;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    height: 700px;
    background-position: 0px 0px;
  }
`;

const BackgroundFilter = styled.div`
  width: 100%;
  height: 100%;
  background-color: #0000e6;
  display: flex;
  flex-direction: column;
`;

const TopSectionInnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;



const StandoutImage = styled.div`
  width: 48em;
  height: 37em;

  img {
    width: 100%;
    height: 100%;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    align-items: center;
  }
`;

const ButtonName = styled.div`

border-radius:36px;
font-size:29px;
color:#ffffff;
padding:14px;
width:600px;

`

const SloganText2 = styled.h3`
  margin: 0;
  line-height: 1.1;
  color: #fff;
  font-weight: 900;
  font-size: 35px;
  

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 24px;
  }
`
const SloganText3 = styled.h3`
  margin: 0;
  line-height: 1.1;
  color: #fff;
  font-weight: 400;
  font-size: 15px;
  margin-top:30px;
  

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 24px;
  }
`
const SloganText = styled.h3`
  margin: 0;
  line-height: 1.1;
  color: #fff;
  font-weight: 900;
  font-size: 55px;
  

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 24px;
  }
`;

export function TopSection(props) {
  const { children } = props;

  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });

  return (
    <TopSectionContainer>
      <BackgroundFilter>
        {children}
        <TopSectionInnerContainer>
          <LogoContainer>
            
            <Marginer direction="vertical" margin={8} />
            <SloganText>Veja como Funciona...</SloganText>
            <SloganText></SloganText>
            <Marginer direction="vertical" margin={15} />
            <SloganText2>Cancelamento do serviço de P.P.A</SloganText2>
            <SloganText2>Proteção veicular automotiva</SloganText2>

            <SloganText3>Preencha seus dados abaixo e prossiga...</SloganText3>
          </LogoContainer>
          {!isMobile && (
            <StandoutImage>
              <img src={TheBestSpecialistsImg} alt="best in the field" />
            </StandoutImage>
          )}
        </TopSectionInnerContainer>
      </BackgroundFilter>
    </TopSectionContainer>
  );
}
